import React from "react";
import { ALL_LANGUAGES } from "../../data/courseDataJapan";

const JapanLanguagesCard = () => (
  <div className="jl-hero__card">
    <span className="jl-hero__live">レッスン受付中</span>
    <strong>対応言語</strong>
    <div className="jl-hero__langs">
      {ALL_LANGUAGES.map((language) => (
        <div key={language.label}>
          {language.flag} {language.label}
        </div>
      ))}
    </div>
  </div>
);

export default JapanLanguagesCard;
